import { render } from "./EmailSent.vue?vue&type=template&id=37581722&scoped=true&ts=true"
import script from "./EmailSent.vue?vue&type=script&lang=ts"
export * from "./EmailSent.vue?vue&type=script&lang=ts"

import "./EmailSent.vue?vue&type=style&index=0&id=37581722&lang=css&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37581722"]])

export default __exports__